import ProductBrowse from "../../views/ProductBrowse";

export default [
  {
    path: "/product/browse",
    // path: "/product",
    component: ProductBrowse,
    props: route => ({
      category: route.query.c,
      subCategory: route.query.sc
    })
  }
];
